module.exports = __webpack_public_path__ + "/static/assets/5f7a79af3db62e0f5b7306ac0bd5ebf9.svg";